import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import theme from "./theme";
import Preloader from "./components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import SocialProof from "./components/SocialProof/SocialProof";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppIcon from "./components/Whatsapp";
import ProjectDetail from "./components/Projects/ProjectDetail";
import "./style.css";

function App() {
  const [load, updateLoad] = useState(true);

  useEffect(() => {
    document.body.classList.add("no-scroll");
    const timer = setTimeout(() => {
      updateLoad(false);
      document.body.classList.remove("no-scroll");
    }, 1200);

    return () => {
      clearTimeout(timer);
      document.body.classList.remove("no-scroll");
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Preloader load={load} />
        <Box
          sx={{
            minHeight: "100vh",
            background: "linear-gradient(135deg, #0a0a0f 0%, #1a1a2e 50%, #0a0a0f 100%)",
            position: "relative",
          }}
        >
          <Box component="a" href="#main-content" className="skip-link">
            Skip to main content
          </Box>
          <Navbar />
          <ScrollToTop />
          <WhatsAppIcon />
          <Box component="main" id="main-content" tabIndex={-1}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/project" element={<Projects />} />
              <Route path="/project/:id" element={<ProjectDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/resume" element={<Resume />} />
              <Route path="/social-proof" element={<SocialProof />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </Box>
          <Footer />
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
